export default "__VITE_ASSET__CYV8YtM___"